import { useEffect } from "react";
import { useLocation } from "react-router";

// ==============================|| NAVIGATION - SCROLL TO TOP ||============================== //

const ScrollTop = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    // This will run every time the route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    // Your side-effect here (e.g., analytics, reset state, etc.)
  }, [location.pathname]);

  return children || null;
};
export default ScrollTop;
